export const THEMES = {
  old: 'old-theme',
  dark: 'dark-theme',
  new: 'new-theme'
}

export const THEME_DEFAULT = 'new'
